import type { IEntityTypeIdentifier } from "./basic.models";

export interface UserModel {
    user: GetRightShipQiUserResponseUser;
    businessUnit: GetRightShipQiUserBusinessUnitResponse;
    businessUnitUserPermissions: any[];
    userCompanyAssociations: any[];
    isUserAzureAD: boolean;
    isCustomerMfaEnabled: boolean;
    isUserMfaExcluded: boolean;
    isUserMfaEnabled: boolean;
    mfaLogout: boolean;
    intercomHash: string;
}

export interface GetRightShipQiUserResponseUser {
    id: number;
    userId: number;
    campaign: string;
    campaignIdentifier: string;
    campaignSource: string;
    campaignMedium: string;
    email: string;
    branchId: number;
    isActive: boolean;
    firstName: string;
    lastName: string;
    fullName: string;
    timeZone: string;
    cultureCode: string;
    guid: string;
    userPhoneNumbers: any[];
    roleUsers: any[];
    entityType: number;
    identifier: string;
    userLogins: any[];
}

export interface GetRightShipQiUserBusinessUnitResponse {
    canAmmendVetRules: boolean;
    businessUnitId?: number;
    businessUnitName: string;
    customerId?: number;
    customerGuid?: string;
    customerName: string;
    shouldPassToRightShipVettingQueue: boolean;
    customerType: string;
    isMepTrialCustomer?: boolean;
    customerMepTrialExpiryDate?: Date;
}

export interface UserPermissionModel {
    permissionId: number;
    category: string;
    categoryId: number;
    parameters: string;
    permissionMappingType: number;
    permission: string;
}

export enum ClaimsRequireTypeEnum {
    RequireAll = 1,
    RequireAny = 2
}

export interface RoleMetaModel {
    roleId: number;
    roleName: string;
    departentName: string;
    impersonationId?: number;
}

export interface UserSecurityInfoModel {
    allowedClaims: UserPermissionModel[];
    roleId: number;
    departmentId: number;
    id: number;
    isManager?: boolean;
    managerId?: number;
    roles: RoleMetaModel[];
    departmentName: string;
    roleName: string;
    userName: string;
    campaign?: string;
    campaignIdentifier?: string;
    campaignSource?: string;
    campaignMedium?: string;
    branchId: number;
    branchName: string;
    email: string;
    accessibleDepartmentIds: number[];
    settings?: any;
    userPhoneNumbers?: UserPhoneNumber[];
    timezone?: string;
    cultureCode?: string;
    createdDate?: Date;
}

export interface UserPhoneNumber extends IEntityTypeIdentifier {
    userId: number;
    phoneId: string;
    phoneNumber: string;
    phoneNumberTypeId: number;
    phoneSequence: number;
}